import URI from 'urijs';
import {ajaxAuthed, API_BASE} from "./common";
import {APIError} from "../common/errors";

export function getCompaniesByManyIds$({ ids = [] }) {
  let idsString = ids.map(id => `id=${encodeURIComponent(id)}`).join('&');
  return ajaxAuthed({ url: `${API_BASE}/companies?${idsString}`});
}

export function getCompanies$({ offset, id, q }) {
  let query = {
    offset,
    id,
    q,
  };
  let url = URI.joinPaths(API_BASE, 'companies');
  url.query(URI.buildQuery(query));
  return ajaxAuthed({ url: url.toString() });
}

export function createCompany$({ company }) {
  if (!company) throw new APIError('no company record specified in createCompany');
  let url = URI.joinPaths(API_BASE, 'companies');
  return ajaxAuthed({ url: url.toString(), method: 'POST', body: company, headers: { 'Content-Type': 'application/json'} });
}

export function getCompanyByShortName$({ qex }) {
  if (!qex) throw new APIError('no search term specified for getCompanyByShortName');
  let url = URI.joinPaths(API_BASE, 'companies');
  url.query(URI.buildQuery({ qex }));
  return ajaxAuthed({ url: url.toString() });
}

export function getCompanyById$({ companyId }) {
  if (!companyId) throw new APIError('no company id specified for getCompanyById');
  let url = URI.joinPaths(API_BASE, 'companies', companyId);
  return ajaxAuthed({ url: url.toString() });
}

export function updateCompany$({ companyId, company }) {
  if (!company) throw new APIError('no company record specified in updateCompany');
  if (!companyId) throw new APIError('no company id specified for getCompanyById');
  let url = URI.joinPaths(API_BASE, 'companies', companyId);
  return ajaxAuthed({ url: url.toString(), method: 'PUT', body: company, headers: { 'Content-Type': 'application/json'} });
}

export function requestToJoinCompany$({ companyId }) {
  if (!companyId) throw new APIError('no company id specified for requestToJoinCompany');
  let url = URI.joinPaths(API_BASE, 'companies', companyId, 'requests');
  return ajaxAuthed({ url: url.toString(), method: 'POST' });
}

export function getCompanyJoinRequests$({ companyId, offset, limit }) {
  if (!companyId) throw new APIError('no company id specified for getCompanyJoinRequests');
  let query = {
    offset,
    limit
  };
  let url = URI.joinPaths(API_BASE, 'companies', companyId, 'requests');
  url.query(URI.buildQuery(query));
  return ajaxAuthed({ url: url.toString(), method: 'GET' });
}

export function acceptCompanyJoinRequest$({ companyId, userId }) {
  if (!companyId) throw new APIError('no company id specified for acceptCompanyJoinRequest');
  if (!userId) throw new APIError('no user id specified for acceptCompanyJoinRequest');
  let url = URI.joinPaths(API_BASE, 'companies', companyId, 'requests', userId, 'accept');
  return ajaxAuthed({ url: url.toString(), method: 'POST' });
}

export function rejectCompanyJoinRequest$({ companyId, userId }) {
  if (!companyId) throw new APIError('no company id specified for rejectCompanyJoinRequest');
  if (!userId) throw new APIError('no user id specified for rejectCompanyJoinRequest');
  let url = URI.joinPaths(API_BASE, 'companies', companyId, 'requests', userId);
  return ajaxAuthed({ url: url.toString(), method: 'DELETE' });
}

export function getCompanyEmployees$({ companyId, offset, limit, id }) {
  if (!companyId) throw new APIError('no company id specified for getCompanyEmployees');
  let url = URI.joinPaths(API_BASE, 'companies', companyId, 'invites');
  let query = {
    id,
    offset,
    limit
  };
  url.query(URI.buildQuery(query));
  return ajaxAuthed({ url: url.toString(), method: 'GET' });
}

export function getCompanyEmployeeSingle$({ companyId, id }) {
  if (!companyId) throw new APIError('no company id specified for getCompanyEmployeeSingle');
  if (!id) throw new APIError('no company id specified for getCompanyEmployeeSingle');
  let url = URI.joinPaths(API_BASE, 'companies', companyId, 'invites', id);
  return ajaxAuthed({ url: url.toString(), method: 'GET' });
}

export function createEmailCompanyInvites$({ companyId, inviteUserEmails = [] }) {
  if (!companyId) throw new APIError('no company id specified for createEmailCompanyInvites');
  let url = URI.joinPaths(API_BASE, 'companies', companyId, 'invites');
  return ajaxAuthed({ url: url.toString(), method: 'POST', body: inviteUserEmails, headers: { 'Content-Type': 'application/json'} });
}

export function updateCompanyEmployeePermissions$({ companyId, userId, permissions }) {
  if (!userId) throw new APIError('no user id specified for updateCompanyEmployeeProfile');
  let url = URI.joinPaths(API_BASE, 'companies', companyId, 'invites', userId);
  return ajaxAuthed({ url: url.toString(), method: 'PUT', body: permissions, headers: { 'Content-Type': 'application/json'} });
}

export function removeCompanyEmployee$({ companyId, userId }) {
  if (!userId) throw new APIError('no user id specified for removeCompanyEmployee');
  let url = URI.joinPaths(API_BASE, 'companies', companyId, 'invites', userId);
  return ajaxAuthed({ url: url.toString(), method: 'DELETE', headers: { 'Content-Type': 'application/json'} });
}

export function getCompanyLogo$({ companyId }) {
  if (!companyId) throw new APIError('no company id specified for getCompanyLogo');
  let url = URI.joinPaths(API_BASE, 'companies', companyId, 'logos');
  return ajaxAuthed({ url: url.toString() });
}

export function updateCompanyLogo$({ companyId, file }) {
  if (!companyId) throw new APIError("No companyId specified for updateCompanyLogo");
  if (!file) throw new APIError("No file specified for updateCompanyLogo");
  const url = URI.joinPaths(API_BASE, 'companies', companyId, 'logos');
  let formData = new FormData();
  formData.append('content', file);
  return ajaxAuthed({ url: url.toString(), method: 'POST', body: formData });
}

export function deleteCompanyLogo$({ companyId }) {
  if (!companyId) throw new APIError('no company id specified for deleteCompanyLogo');
  let url = URI.joinPaths(API_BASE, 'companies', companyId, 'logos');
  return ajaxAuthed({ url: url.toString(), method: 'DELETE' });
}



// WEBPACK FOOTER //
// ./src/services/companies.js